import type { Edge2dComputed, Face2dComputed } from "../../mesh"
import { wrapAround } from "../../utils"

export const faceToEdges = ({ nodes }: Face2dComputed): Edge2dComputed[] => {
  const segments: Edge2dComputed[] = []
  for (let a = 0, b = 1; a < nodes.length; a++, b++) {
    b = wrapAround(b, [0, nodes.length])
    segments.push({
      p1: nodes[a],
      p2: nodes[b],
    })
  }

  return segments
}
